import React from "react";

import { Accordion } from "rsuite";
import { Tabs, Tab } from "react-bootstrap";
import TableHeader from "@components/TableHeader";
import Printfiled from "./Printfiled";
import { useTranslation } from "react-i18next";

import { useModal } from "@components/ModalContext";
import Roomadd from "./Roomadd";
import { useDispatch, useSelector } from "react-redux";
import { addRoom } from "@services/redux/slices/hotelSlice";
import { MdOutlineAddCircle } from "react-icons/md";

const Hotel = (props) => {

    const { t } = useTranslation();
     const { openModal, setFullscreen, setTitle,setModalBodyClass } = useModal();
console.log('rooms list',props)
     
    const Newroom = async () => {

    setFullscreen(true);
    setModalBodyClass('bg-light')
    setTitle(t("new_room"));
    openModal(<Roomadd id={props.productId} />); 
    setFullscreen(false)
  };
   
  return (
    <>
      {" "}
       <div>
         <button
                appearance="primary"
                className="mb-3 p-3 btn-blue rounded-2"
                onClick={() => Newroom()}
              >
               <MdOutlineAddCircle className="me-1" size={20}/> {t("add_room")}
              </button>
       </div>
       
      <Accordion defaultActiveKey={0} bordered className="bg-white">
        {props.prices.map((room, roomIndex) => (
          <PanelComponent
            room={room}
            roomIndex={roomIndex}
            t={props.t}
            config={props.config}
            priceForm={props.priceForm}
            onStopSales={props.onStopSales}
            profile={props.profile}
          />
        ))}
      </Accordion>
    </>
  );
};

const PanelComponent = ({
  room,
  roomIndex,
  t,
  config,
  priceForm,
  onStopSales,
  profile,
}) => {
  const header = [
    {
      title: "tarif_date",
      width: 7,
      align: "left",
      filed: "date",
    },
    {
      title: "availability",
      width: 8,
      align: "center",
      filed: "rooms_available",
    },
    {
      title: "base_amount",
      width: 18,
      align: "center",
      filed: "base_amount",
      filedList: ["price"],
    },
    {
      title: "charge",
      width: 18,
      align: "center",
      filed: "charge",
      filedList: ["price"],
    },
    {
      title: "amount_traveler",
      width: 18,
      align: "center",
      filed: "amount_traveler",
      filedList: ["price"],
    },
    {
      title: "you_earn",
      width: 18,
      align: "center",
      filed: "you_earn",
      filedList: ["price"],
    },
    { title: "", width: 5, align: "center", filed: "is_stop_sales" },
    { title: "", width: 5, align: "center", filed: "button" },
  ];

  return (

    <Accordion.Panel
      header={
        <div className="p-3">
          <span className="fs-5 fw-bold" style={{ color: "gray" }}>
            {room.roomName}
          </span>
          <p className="mt-1 fw-normal">{t("ho_act_Opt_TarifTxt1")}</p>
        </div>
      }
      eventKey={roomIndex}
    >
      <Tabs defaultActiveKey={0} id="board-tabs" className="custom-tabs">
        
        <Tab eventKey="0" title={room.meal}>
          <div class="tableFixHead">
            <table>
              <TableHeader header={header} />
              <tbody>
                {room.prices.map((tarif, rowIndex) => (
                  <tr key={rowIndex}>
                    {header.map((head) => (
                      <td
                        className="cell100"
                        style={{
                          textAlign: head.align,
                        }}
                      >
                        <Printfiled
                          tarif={tarif}
                          filed={head.filed}
                          filedList={head?.filedList}
                          onStopSales={onStopSales}
                          priceForm={priceForm}
                          config={config}
                          dataIndex={{
                            item: tarif,
                            index: rowIndex,
                            roomIndex: roomIndex,
                          }}
                        />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Tab>
      </Tabs>
    </Accordion.Panel>
 
  );
};

export default Hotel;
